export default __webpack_public_path__ + "static/media/photo--lg--wheel-8.151ec88d.jpg";